import { createI18n } from 'vue-i18n';
import en from '../../public/en.json';
import ja from '../../public/ja.json';
import fra from '../../public/fra.json';
import ms from '../../public/ms.json';
import id from '../../public/id.json';
import zh from '../../public/zh.json';
const messages = {
  en,
  ja,
  fra,
  ms,
  id,
  zh,
};

const i18n = createI18n({
  locale: 'en',
  legacy: false,
  messages
});
export default i18n;
